import React from 'react';
import { useState} from 'react'; 

import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin , faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import { faPhone, faMapMarkerAlt, faEnvelope, faMobile} from '@fortawesome/free-solid-svg-icons';

import './styling/Footer.css'; 
import logoimg from './styling/images/logo.png'


const Footer = () => {
  const [activeSection, setActiveSection] = useState(null);
 
  const toggleSection = (index) => {
    setActiveSection((prev) => (prev === index ? null : index));
  };
  return (
    <footer className="footer-container">
        <div className="footer-first-section">
        <div className='logo'>
        <img src={logoimg}  alt="Logo"/>
        </div>
    
    <p>
    <FontAwesomeIcon icon={faMapMarkerAlt} className="contact_icon" />
      <b>Address:</b> G-09, Odeon Centre, Regal Saddar, Karachi
      </p>
      
    <p>
      
    <FontAwesomeIcon icon={faPhone} className="contact_icon" />
      <b>Phone:</b> +92 21 32734269
      </p> 
      
      <p>
        
      <FontAwesomeIcon icon={faMobile}  className="contact_icon"/>
        <b>Mobile
          / 
      <FontAwesomeIcon icon={faWhatsapp}  className="contact_icon"/>
          WhatsApp:</b> +92 333 2113055, +92 335 2929894 </p>
      
      <p>
        
      <FontAwesomeIcon icon={faEnvelope} className="contact_icon"/>
         <b>Email:</b> arosepowertechnologies@outlook.com, business@arosepowertechnologies.com</p>
  </div>
      <div className="footer-content">
        
        <div className={`footer-section ${activeSection === 1 ? 'active' : ''}`}>
        <h3 onClick={() => toggleSection(1)}>PRODUCTS</h3>
          <ul>  
            <li><Link to="/product_items/Ups" className="page-link">UPS</Link></li>
            <li><Link to="/product_items/Stabilizer" className="page-link">Stabilizer</Link></li>
            <li><Link to="/product_items/LineConditioner" className="page-link">Line Conditioner</Link></li>
            <li><Link to="/product_items/Solar" className="page-link">Solar</Link></li>
            <li><Link to="/product_items/ManualRegulator" className="page-link">Manual Regulator</Link></li>
            <li><Link to="/product_items/Battery" className="page-link">Battery</Link></li>
            <li><Link to="/product_items/Transformer" className="page-link">Transformer</Link></li>
        
          </ul>
        </div>
        <div className={`footer-section ${activeSection === 2 ? 'active' : ''}`}>
          <h3 onClick={() => toggleSection(2)}>INFORMATION</h3>
          <ul>
            <li><Link to="/Profile" className="page-link">Profile</Link></li>
            <li><Link to="/Certifications" className="page-link">Certifications</Link></li>
            <li><Link to="/Dealerships" className="page-link">Dealerships</Link></li>
            <li><Link to="/RepairingAndServiceContracts" className="page-link">Repairing & Service Contracts</Link></li>
            <li><Link to="/ClientList" className="page-link">Client List</Link></li>
          </ul>
        </div>
        <div className='followus'>
          <h4>FOLLOW US</h4>
           
            <div className="social-icons">
                        <a href="https://www.facebook.com/arosepowertechnologies"  target="_blank" rel="noopener noreferrer" className="icon" title="Facebook">
                          <FontAwesomeIcon icon={faFacebook} />
                        </a> 
                        <a href="https://wa.me/923332113055"  target="_blank" rel="noopener noreferrer" className="icon" title="Whatsapp">
                          <FontAwesomeIcon icon={faWhatsapp} />
                        </a>
                        <a href="https://www.instagram.com/arosepowertechnologies"  target="_blank" rel="noopener noreferrer" className="icon" title="Instagram">
                          <FontAwesomeIcon icon={faInstagram} />
                        </a>
                        <a href="https://www.linkedin.com/in/arosepowertechnologies"  target="_blank" rel="noopener noreferrer" className="icon" title="LinkedIn">
                          <FontAwesomeIcon icon={faLinkedin} />
                        </a>
                      </div>
            
          
        </div>
        
      </div>
      <div className="footer-bottom">
        <p>Copyright &copy; 2025. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;